import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { computed, defineComponent, nextTick, ref, toRefs, watch } from "@vue/composition-api";
import { uniqueId } from "lodash";
import AutocompleteInput from "../inputs/autocomplete-input.vue";
import SectionError from "./section-error.vue";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "AutocompleteSection",
  components: {
    AutocompleteInput,
    SectionError
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    id: {
      type: String,
      default: () => uniqueId("automcomplete")
    },
    placeholder: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    containerClass: {
      type: String,
      default: ""
    },
    maxLength: {
      type: [String, Number],
      default: null
    },
    max: {
      type: String,
      default: null
    },
    autoFill: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: ""
    },
    companyAddress: {
      type: Boolean,
      default: false
    },
    value: {
      type: null,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      value: propValue
    } = toRefs(props);
    const rawValue = ref("");
    const labelValue = uuidv4();
    const localVerificationValueLength = computed(() => {
      var _rawValue$value;
      return ((_rawValue$value = rawValue.value) == null ? void 0 : _rawValue$value.toString().length) || 0;
    });
    watch(propValue, val => {
      rawValue.value = val;
    }, {
      immediate: true
    });
    const handleChange = address => {
      emit("change", address);
    };
    const getInputValue = value => {
      if (value === "") return null;
      if (props.maxLength) {
        var _context;
        return (value == null ? void 0 : _sliceInstanceProperty(_context = value.toString()).call(_context, 0, _parseInt(props.maxLength.toString()))) || "";
      }
      return value;
    };
    const handleValueChange = eventValue => {
      rawValue.value = getInputValue(eventValue);
      nextTick(() => {
        emit("value-change", rawValue.value);
      });
    };
    const getContainerClass = () => {
      return `${props.containerClass} ${props.maxLength ? "floating-validation-container" : ""} ${props.errorMessage ? "error" : ""}`;
    };
    const companyAddressMode = computed(() => {
      var _context2;
      return _includesInstanceProperty(_context2 = props.className).call(_context2, "company-address") || props.companyAddress;
    });
    const handlePhoneNumberChange = eventValue => {
      emit("phone-number-change", eventValue);
    };
    return {
      handleChange,
      handleValueChange,
      handlePhoneNumberChange,
      localVerificationValueLength,
      getContainerClass,
      rawValue,
      companyAddressMode,
      labelValue
    };
  }
});